import { render, staticRenderFns } from "./ImageEx.vue?vue&type=template&id=be1f63c8&"
import script from "./ImageEx.vue?vue&type=script&lang=ts&"
export * from "./ImageEx.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports